import { render, staticRenderFns } from "./BonusTabs.vue?vue&type=template&id=8e094d4a&scoped=true&"
import script from "./BonusTabs.vue?vue&type=script&lang=js&"
export * from "./BonusTabs.vue?vue&type=script&lang=js&"
import style0 from "./BonusTabs.vue?vue&type=style&index=0&id=8e094d4a&prod&lang=scss&scoped=true&"
import style1 from "./BonusTabs.vue?vue&type=style&index=1&id=8e094d4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e094d4a",
  null
  
)

export default component.exports